import { API_URL } from '../api';

// Resolve a backend-served static path (e.g. /cache/prefetch/*.json) against the API origin
function resolveBackend(path: string): string {
  try {
    if (/^https?:\/\//i.test(path)) return path;
    const origin = new URL(API_URL, typeof window !== 'undefined' ? window.location.origin : 'http://localhost:3000').origin;
    return new URL(path.startsWith('/') ? path : `/${path}`, origin).toString();
  } catch {
    return path;
  }
}

export async function getFacrClubInfoCache(): Promise<any | null> {
  const url = resolveBackend('/cache/prefetch/facr_club_info.json');
  const res = await fetch(url, { cache: 'no-cache' });
  if (!res.ok) return null;
  return res.json();
}

export async function getFacrTablesCache(): Promise<any | null> {
  const url = resolveBackend('/cache/prefetch/facr_tables.json');
  const res = await fetch(url, { cache: 'no-cache' });
  if (!res.ok) return null;
  return res.json();
}
